import { render, staticRenderFns } from "./tut.vue?vue&type=template&id=1613cfc8&scoped=true&"
import script from "./tut.vue?vue&type=script&lang=js&"
export * from "./tut.vue?vue&type=script&lang=js&"
import style0 from "./tut.vue?vue&type=style&index=0&id=1613cfc8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1613cfc8",
  null
  
)

export default component.exports